export const testRoute = {
  path: "/test",
  component: () => import("@/views/test/index.vue"),
};
